// src/components/Dashboard.js
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import WaitlistManagement from './WaitlistManagement';

const Dashboard = () => {
  const { user, profile } = useAuth();
  const role = user?.role ?? profile?.role;

  if (!role) {
    return null;
  }

  if (role !== 'owner') {
    if (role === 'parent') {
      return <Navigate to="/parent-dashboard" replace />;
    }
    if (role === 'therapist') {
      return <Navigate to="/therapist-dashboard" replace />;
    }
    if (role === 'receptionist') {
      return <Navigate to="/receptionist-dashboard" replace />;
    }
    return <Navigate to="/" replace />;
  }

  return <WaitlistManagement />;
};

export default Dashboard;
